import { Button, ButtonBase, Divider, Grid, Menu, MenuItem, Tab } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { getInfosIndividual } from '@webapps/business';
import { Loader, Modal, useAuth, useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import MessageBox from 'components/MessageBox';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import Business from './Components/Business';
import Document from './Components/Document';
import InfoContract from './Components/InfoContract';
import School from './Components/School';


import Achievement from '../../pages/Cvtheque/Components/detailed/Components/Achievement';
import Certification from '../../pages/Cvtheque/Components/detailed/Components/Certification';
import CompetenciesPerso from '../../pages/Cvtheque/Components/detailed/Components/CompetenciesPerso';
import CompetenciesPro from '../../pages/Cvtheque/Components/detailed/Components/CompetenciesPro';
import Contact from './Components/Contact';
import Criteria from './Components/Criteria';
import Description from '../../pages/Cvtheque/Components/detailed/Components/Description';
import Education from '../../pages/Cvtheque/Components/detailed/Components/Education';
import Experience from '../../pages/Cvtheque/Components/detailed/Components/Experience';
import Interest from '../../pages/Cvtheque/Components/detailed/Components/Interest';
import Language from '../../pages/Cvtheque/Components/detailed/Components/Language';
import LanguageProg from '../../pages/Cvtheque/Components/detailed/Components/LanguageProg';
import Permit from '../../pages/Cvtheque/Components/detailed/Components/Permit';
import Software from '../../pages/Cvtheque/Components/detailed/Components/Software';
import Transport from '../../pages/Cvtheque/Components/detailed/Components/Transport';
import Information from 'components/Icons/Information';
import PlanningProfilSidebar from 'pages/school/ClassesPage/ClassesDetail/Components/PlanningProfilSidebar';
import { CalendarProvider } from 'pages/school/ClassesPage/ClassesDetail/Stores/CalendarProvider';


const ProfilSidebar = ({ id, typeOrganism, classroomId, defaultTabValue, displayPlanning = false }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const [value, setValue] = useState('1');

  useEffect(() => {
    if (defaultTabValue) {
      setValue(defaultTabValue);
    }
  }, [defaultTabValue]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [openMessageBox, setOpenMessageBox] = useState(false);

  const handleOpenMessageBox = () => {
    setOpenMessageBox(true);
  };
  const handleCloseMessageBox = () => {
    setOpenMessageBox(false);
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [openDeleteClasses, setOpenDeleteClasses] = useState(false);
  const handleOpenDeleteClasses = () => {
    setOpenDeleteClasses(true);
  };

  const handleCloseDeleteClasses = () => {
    setOpenDeleteClasses(false);
  };

  const {
    data: info = {},
    refetch,
    isLoading,
  } = useQuery(getInfosIndividual, {
    key: ['indivudualInfos', id],
    variables: { id },
  });

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={classes.container}>

      <TabContext value={value}>
        <div>
          <TabList
            className={css({
              background: 'white',
            })}
            indicatorColor="default"
            onChange={handleChange}
          >
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: '1px solid #C0D9FF',
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                  background: value === '1' ? 'white' : '#F3F7FF',
                  color: value === '1' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '1' ? 600 : 400,
                  width: '25%'
                }),
              }}
              className={global.mainTitle}
              label="Informations"
              value="1"
            />
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: '1px solid #C0D9FF',
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                  background: value === '2' ? 'white' : '#F3F7FF',
                  color: value === '2' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '2' ? 600 : 400,
                  width: '25%'
                }),
              }}
              className={global.mainTitle}
              label="CV"
              value="2"
            />
            <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: '1px solid #C0D9FF',
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                  background: value === '3' ? 'white' : '#F3F7FF',
                  color: value === '3' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '3' ? 600 : 400,
                  width: '25%'
                }),
              }}
              className={global.mainTitle}
              label="Documents"
              value="3"
            />
            {displayPlanning && <Tab
              classes={{
                root: css({
                  border: '1px solid #C0D9FF',
                  borderBottom: '1px solid #C0D9FF',
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                  background: value === '4' ? 'white' : '#F3F7FF',
                  color: value === '4' ? '#152652' : '#5A6DA1',
                  fontWeight: value === '4' ? 600 : 400,
                  width: '25%'
                }),
              }}
              className={global.mainTitle}
              label="Planning"
              value="4"
            />}
          </TabList>
        </div>
        <TabPanel className={classes.infoContainer} value="1">
          <Contact info={info} />
          <Divider style={{ marginTop: spacing(3) }} />
          {/* <Contrat id={id} refetch={refetch} /> */}
          <School UserId={id} typeOrganism={typeOrganism} />
          <Divider style={{ marginTop: spacing(3) }} />
          <Business UserId={id} typeOrganism={typeOrganism} />
          <Divider style={{ marginTop: spacing(3) }} />
          <InfoContract info={info} typeOrganism={typeOrganism} />
        </TabPanel>
        <TabPanel className={classes.cvContainer} value="2">
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <Criteria info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <Description info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <Language info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <Interest info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <Transport info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <Permit info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <CompetenciesPerso info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <CompetenciesPro info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <Software info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(3) })} item xs={12}>
              <LanguageProg info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <Education info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <Experience info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <Certification info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
            <Grid className={css({ marginTop: spacing(2) })} item xs={12}>
              <Achievement info={info} />
              <Divider style={{ marginTop: spacing(3) }} />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel className={classes.docContainer} value="3">
          <Document UserId={id} OrganismId={idUser} />
        </TabPanel>
        {displayPlanning && <TabPanel className={classes.planningContainer} value="4">
          <CalendarProvider>
            <PlanningProfilSidebar
              classroomId={classroomId}
            />
          </CalendarProvider>
        </TabPanel>}
      </TabContext>
      <Modal
        onCancel={handleCloseMessageBox}
        open={openMessageBox}
        // subTitle="Envoyez un message aux candidats et gardez contact dans votre
        // messagerie"
        title="Envoyer un message"
        withStep={false}
      >
        <div className={css({ display: 'flex', flexDirection: 'row' })}>
          <span>
            <Information className={css({ color: '#0060F9', height: 20, width: 20, marginRight: 10 })} />
          </span>
          <div className={css({ fontSize: 14, color: 'rgba(0, 0, 0, 0.87)' })}>
            Envoyez un message aux candidats et gardez contact dans votre
            messagerie
          </div>
        </div>
        <MessageBox id={id} onCancel={handleCloseMessageBox} />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    height: '100%',
  },
  btnContainer: {
    display: 'flex',
    padding: spacing(0, 2),
    marginBottom: spacing(2),

    columnGap: spacing(1.5),
  },
  btn: {
    borderRadius: '10.0px',
  },
  buttonAction: {
    alignItems: 'center',
    border: '1px solid #C0D9FF',
    borderRadius: '10.0px',
    padding: spacing(1),
  },
  infoContainer: {
    padding: spacing(2.5),
    '& > *': {
      marginBottom: spacing(3),
    },
    '@media only screen and (max-width:768px)': { padding: spacing(0) }

  },
  planningContainer: {
    padding: "20px 0px 20px 0px",
    // '& > *': {
    // marginBottom: spacing(3),
    // },
    // '@media only screen and (max-width:768px)': { padding: spacing(0) }

  },
  cvContainer: {
    padding: spacing(2, 2, 0, 0),
    marginTop: spacing(1),
    '& > *': {
      marginBottom: spacing(2),
    },
    '@media only screen and (max-width:768px)': { padding: spacing(0) }

  },
  docContainer: {
    padding: spacing(2.5, 0),
    marginTop: spacing(1),
    '& > *': {
      marginBottom: spacing(2),
    },
    '@media only screen and (max-width:768px)': { padding: spacing(0) }
  },

});

ProfilSidebar.propTypes = {
  id: PropTypes.string,
  typeOrganism: PropTypes.string,
};

export default ProfilSidebar;
